export const Status = {
  1: {titulo: 'Retirada pelo Proprietário', class: '', color: ''},
  2: {titulo: 'Retirada pelo Representante Legal', class: '', color: ''},
  3: {titulo: 'Retirada por Decisão Judicial', class: '', color: ''},
  4: {titulo: 'Retirada por Prensa', class: '', color: ''},
  5: {titulo: 'Retirada por Leilão', class: '', color: ''},
  // 6: {titulo: 'Retirada por Leilão Externo', class: '', color: ''},
  7: {titulo: 'Retirada por Roubo ou Furto', class: '', color: ''},
  8: {titulo: 'Retirada por Leilão pelo Representante Legal', class: '', color: ''},
  9: {titulo: 'Retirado pelo representante legal - Óbito', class: '', color: ''}
}

export const StatusTitle = function (s, t) {
  t = typeof t !== 'undefined' ? t : 'titulo'
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s][t]
}

export const STATUS_RETIRADO_PELO_PROPRIETARIO = 1
export const STATUS_RETIRADO_POR_DECISAO_JUDICIAL = 3
export const STATUS_RETIRADO_POR_LEILAO = 5
// export const STATUS_RETIRADO_POR_LEILAO_EXTERNO = 6
export const STATUS_RETIRADO_POR_LEILAO_REPRESENTANTE_LEGAL = 8

export const ARRAY_STATUS_RETIRADO_POR_LEILAO = [
  STATUS_RETIRADO_POR_LEILAO,
  STATUS_RETIRADO_POR_LEILAO_REPRESENTANTE_LEGAL
]

export function isRetiradoPorLeilao (status) {
  return ARRAY_STATUS_RETIRADO_POR_LEILAO.includes(status)
}



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/retirada-status.js